/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { Heading, ProgressBar } from 'mondrian-react';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { useJourney } from '~/hooks/journey';
import { Container } from './styles';

import bgClaro from '../../../assets/images/bg-claro.svg';
import accept from '../../../assets/images/accept.png';

export const IntroCategory = () => {
  const { initPreJourney, hasPreJourney, progress } = useJourney();

  useEffect(() => {
    const checkCategory = async () => {
      if (!hasPreJourney) {
        await initPreJourney();
      }
    };
    checkCategory();
  }, [initPreJourney, hasPreJourney]);

  return (
    <Container>
      <div className="content">
        <Heading xs className="content-subtitle">
          Olá, tudo bem?
        </Heading>
        <Heading className="content-title">Bem vindo a Claro</Heading>
        <div className="content-body">
          <div>
            <img
              className="img mdn-Icon--md"
              src={accept}
              alt="Desligue o WI-FI icon"
            />
            <p>
              <span className="bold">Estamos conferindo sua linha</span>, por
              favor aguarde alguns instantes!
            </p>
          </div>
        </div>
        <img
          className="background-claro"
          src={bgClaro}
          alt="Logotipo da Claro"
        />
      </div>

      <div className="footer-action">
        <div className="progress-base">
          <ProgressBar progress={100} value={progress} isVisible />
        </div>
      </div>
    </Container>
  );
};
